export const deliveryFeatureTranslationJP = {
  DeliveryFeature: {
    Component: {
      test_reflection: 'テスト反映',
      search: '検索',
      csv_output: 'CSV出力',
      delete: '削除',
      close: '閉じる',
      setting: '設定',
      apply: '申請',
      confirm: '確認',
      approve: '承認',
      reject: '却下',
      reject_confirm: '確認取消',
      cancel_apply: '申請取消',
      send_back: '差戻',
      cancel_approve: '申請取消',
      cancel_confirm: '申請取消',
      edit: '再編集', // 追加: 再編集
    },
    Text: {
      distribution_setting_status_list: '配信設定／状況一覧',
      it_is_a_required_field: '※は必須項目です。',
      delivery_history_search: '配信履歴検索',
      delivery_date: '配信日',
      data_date: '配信店舗対象日',
      content: '配信内容',
      approval_state: '承認状態',
      delivery_status: '配信状態',
      new_distribution_setting: '新規配信設定',
      apply: '配信申請',
      list_of_distribution_status: '配信状況一覧',
      all: '全て',
      distribution_settings: '配信設定',
      distribution_unit: '配信単位',
      sales_type: '販売タイプ',
      counter_pattern: 'レジパターン',
      test_date: '反映日：',
      edit: '再編集', // 追加: 再編集
      editing: '再編集中',
      target_schema: '反映対象データ：',
      target_schema_default: '配信対象データ：',
      delivery_creation_in_progress: '配信作成中',
      delivery_created_successfully: '配信が正常に作成されました',
    },
    Table: {
      selection: '選択',
      distribution_no: '配信No',
      distribution_unit: '配信単位',
      sales_target: '販売対象',
      scheduled_distribution_date: '配信日',
      distribution_status: '配信状態',
      approval_state: '承認状態',
      applicant: '申請者',
      application_date: '申請日',
      confirmer: '確認者',
      date_confirmed: '確認日',
      recognized: '承認者',
      approval_date: '承認日',
      store_code: '店舗コード',
      store_name: '店舗名',
      sales_type: '販売タイプ',
      regular_pattern: 'レジパターン',
      distribution_date: '配信日',
      delivery_content: '配信内容',
      test_reflection: 'テスト反映',
      edit: '再編集', // 追加: 再編集
    },
    Alert: {
      db_version_mismatch: '再編集データは現在のオーサリングツールバージョンが異なるため再編集できません。',
    },
    Confirm: {
      restore_schema: 'この操作を続行しますか？',
      reject_approve: '却下すると、配信申請が削除状態になります。再度編集したい場合は、再編集モードから編集が必要になります。よろしいですか？',
    },
  },
};
